import { tv } from 'tailwind-variants';
import { colors } from './colors.const';

export const buttonIconStyles = tv({
  slots: {
    base: [
      'group relative inline-flex select-none items-center justify-center font-medium rounded-lg cursor-pointer',
      'data-[ui-disabled]:cursor-not-allowed data-[ui-disabled]:[&a]:pointer-events-none data-[loading]:cursor-progress',
      'focus-visible:outline-none'
    ],
    loader: '',
    ripple: 'bg-current',
    overlay: [
      'absolute inset-0 overflow-hidden bg-fixed opacity-0 transition',
      'duration-300 ease-in-out rounded-[inherit] bg-current'
    ]
  },
  variants: {
    variant: {
      filed: {
        base: 'bg-primary text-white shadow-md data-[ui-disabled]:bg-black/10 data-[ui-disabled]:text-black/25',
        overlay: 'bg-white group-hover:opacity-30'
      },
      outlined: {
        base: 'border border-solid border-stroke text-primary data-[ui-disabled]:bg-black/10 data-[ui-disabled]:text-black/25',
        overlay: 'bg-current group-hover:opacity-10'
      },
      toned: {
        base: 'border-none bg-primary/10 text-primary data-[ui-disabled]:bg-black/10 data-[ui-disabled]:text-black/25',
        overlay: 'bg-current group-hover:opacity-10'
      },
      text: {
        base: 'border-none text-primary  data-[ui-disabled]:text-black/25',
        overlay: 'bg-current group-hover:opacity-10'
      }
    },
    color: {
      primary: '',
      secondary: '',
      tertiary: '',
      black: '',
      success: '',
      good: '',
      neutral: '',
      info: '',
      error: '',
      warning: ''
    },
    size: {
      xs: {
        base: 'size-6 [&>.icon]:size-3',
        loader: 'size-3'
      },
      sm: {
        base: 'size-8 [&>.icon]:size-4',
        loader: 'size-4'
      },
      md: {
        base: 'size-10 [&>.icon]:size-5',
        loader: 'size-5'
      },
      lg: {
        base: 'size-12 [&>.icon]:size-6',
        loader: 'size-6'
      },
      xl: {
        base: 'size-14 [&>.icon]:size-7',
        loader: 'size-7'
      }
    },
    rounded: {
      true: 'rounded-full'
    },
    flat: {
      true: 'shadow-none'
    },
    tile: {
      true: 'rounded-none'
    }
  },
  compoundVariants: [
    // region Filled Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'filled',
          class: item.filled
        }) as any
    ),
    // endregion Filled Variant
    // region Toned Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'toned',
          class: item.toned
        }) as any
    ),
    // endregion Toned Variant
    // region Outlined Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'outlined',
          class: item.outlined
        }) as any
    ),
    // endregion Outlined Variant
    // region Text Variant
    ...colors.map(
      (item) =>
        ({
          color: item.color,
          variant: 'text',
          class: item.text
        }) as any
    )
    // endregion Text Variant
  ],
  defaultVariants: {
    size: 'md',
    variant: 'text'
  }
});
